export enum Routes {
    Main = '/',
    Projects = '/projects',
    Dashboard = '/supervising/wells/dashboard',
    Wells = '/supervising/wells',
    WellsAnalytics = '/wells-analytics',
    StageAnalytics = '/stage-analytics',
    Files = '/supervising/wells',
    InstrumentMeasure = '/supervising/wells/instrument-measure',
    Calendar = '/supervising/wells/calendar',
    Tables = '/supervising/wells/tables',
    Knbk = '/supervising/wells/knbk',
    Ccdp = '/supervising/wells/ccdp',
    Prices = '/prices',
    Price = '/price',
    RatesAndPrices = '/rates-and-prices',
    CommonInfo = '/common-info',
    Monitoring = '/monitoring',
    KnbkGis = '/supervising/wells/knbk-gis',
    KnbkProject = '/knbk-project',
    KnbkDrilling = '/knbkDrilling',
    LessonsDatabase = '/lessons-database',
    Ggd = '/supervising/wells/ggd',
    Trajectory = '/supervising/wells/trajectory',
    SMBO = '/smbo',
    AutoDrilling = '/auto-drilling',
    DrillingCarpet = '/drilling-carpet',
    CommonReportInformations = '/commonReportInformations',
    OperationCalendar = '/operationCalendar',
    Administration = '/administration',
    Accounts = '/accounts',
    WellCommonDashboard = '/supervising/wells/wellCommonDashboard',
    Kpodp = '/supervising/wells/kpodp',
    WellsQuantity = '/supervising/wells-quantity',
    MyResources = '/my-resources',
    ResourceCommonDashboard = '/resourceCommonDashboard',
    Staff = '/staff',
    Storage = '/storage',
    Posts = '/posts',
    MudAnalytics = '/supervising/wells/mud-analytics',
    NciAdministration = '/nci-administration',
    DrillingDates = '/drilling-dates',
    DrillingRig = '/drilling-rig',
    DrillingRigInWell = '/drilling-rig-in-well',
    WellRisks = '/well-risks',
    DrillBitAnalytics = '/drill-bit-analytics',
    Chisels = '/supervising/wells/chisels',
    TechnicalSupport = '/technical-support',
    TestDrillBitCharts = '/test-drill-bit-charts',
    DataManager = '/data-manager',
    Miniapp = '/mini-app',
    ResourcesNpt = '/resources-npt',
}
